import { cn } from "@pma/utils/helpers"

// ** Custom Components
import LeftSection from "./LeftSection"
import RightSection from "./RightSection"

interface HeaderProps {
  className?: string
  onMenuClick?: () => void
}

const Header = ({ onMenuClick }: HeaderProps) => {
  return (
    <header className='flex gap-4 rounded-t-lg border-b border-neutral-100 bg-white px-3 py-2 md:px-6 md:py-3'>
      <div className='flex w-full items-center justify-between'>
        <LeftSection onMenuClick={onMenuClick} />
        <RightSection />
      </div>
    </header>
  )
}

export default Header
